import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../helper/APIUtils";
import {enumToSelectData, selectServiceData, showAxiosError} from "../../helper/helper";
import CreateCreditPool from "./CreateCreditPool";
import NavBarKS from "../../components/NavBarKS";
import {EntegratorConf, VirtualHost} from "../../constants";
import StickButton from "../../components/StickButton";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Footer from "../../components/Table/Footer";
import Alert from "react-s-alert";
import Pagination from "rc-pagination";
import Select from "rc-select";
import locale from 'rc-pagination/lib/locale/tr_TR';
import {CreditPoolType, EntegratorIdentifiers} from "../../helper/enums";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";

class CreditPoolList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			currentPoolId: '',
			newPoolId: null,
			currentCustomers: [],
			creditOperationsModal: false,
			observeModal: false,
			addPoolModal: false,
			addPoolModalHeader: '',
			selectedRow: null,
			formattedCreditPoolList: [],
			searchedVknTckn: '',
			loading: false,
			total: 0,
			page: 0,
			size: 10,
			manual: false,
			mode: 'create',
			poolCustomers:[],
			noResult:[],
			creditPoolType: CreditPoolType.DOCUMENT_COUNT.value
		};

        this.fetchData = this.fetchData.bind(this);
        this.prepareRawData = this.prepareRawData.bind(this);
        this.openAddPoolModalAsEdit = this.openAddPoolModalAsEdit.bind(this);
        this.filterList = this.filterList.bind(this);
        this.closeAddPoolModal = this.closeAddPoolModal.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.pageSize = this.pageSize.bind(this);
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
        this.onChange = this.onChange.bind(this);
		this.onChangeSearchFieldsValue = this.onChangeSearchFieldsValue.bind(this);
    }

	componentDidMount() {
		this.fetchData(undefined,undefined,this.state.page,this.state.size);
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/creditPool/getCreditPoolList?' + 'creditPoolType=' + self.state.creditPoolType + '&page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "post",
		};
		self.setState({loading: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		request(params)
		.then(function (response) {
			self.props.reload(false);
			if (response.data.totalElements === undefined){
				self.setState({noResult: true});
			}else{
				self.setState({data: response.data.content,total: response.data.totalElements, noResult: false});
			}
		}).catch(function (error) {
			self.setState({loading: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	prepareRawData(data) {
		let formattedCreditPoolList = [];
		data.map(content => {
			let tempObj = {
				creditPoolId: null,
				customers: [],
				count: null
			};
			tempObj.creditPoolId = content[0];
			tempObj.count = content[2];
			formattedCreditPoolList.push(tempObj);
		});
		this.setState({formattedCreditPoolList});
	}

	openAddPoolModalAsEdit(creditPoolId) {
		this.setState({
			mode: 'edit',
			addPoolModal: true,
			selectedRow: creditPoolId
		});
	}

	closeAddPoolModal(type) {
		this.setState({
			mode: 'create',
			addPoolModal: false,
			manual: true,
		});
		if (type === "editSuccessful"){
			Alert.success("Havuz başarılı bir şekilde güncellendi.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.fetchData(this.state.accessor, this.state.direction,this.state.page,this.state.size);
		}else if (type === "createSuccessful"){
			Alert.success("Havuz başarılı bir şekilde oluşturuldu.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.fetchData(this.state.accessor, this.state.direction,this.state.page,this.state.size);
		}else if (type === "deletedSuccessful"){
			Alert.error("Havuz silindi.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.fetchData(this.state.accessor, this.state.direction,this.state.page,this.state.size);
		}

	}

	filterList(e) {
		this.setState({
			searchedVknTckn: e.target.value
		}, () => {
			this.state.formattedCreditPoolList.map(pool => {
				pool.customers.map(customer => {
					if (this.state.searchedVknTckn === customer) {
						let formattedCreditPoolList = [];
						formattedCreditPoolList.push(pool);
						this.setState({
							formattedCreditPoolList
						})
					}
				})
			})
		});
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

    pageSize(page, size) {
        this.setState({page: page, size: size});
        this.fetchData(this.state.accessor, this.state.direction, page, size);

    }

    onShowSizeChange(current, pageSize) {
        if (isNaN(pageSize)) {
            current = 1;
            pageSize = this.state.total;
        }
        this.pageSize(current - 1, pageSize);
    }

    onChange(current, pageSize) {
        this.pageSize(current - 1, pageSize);
    }

	onChangeSearchFieldsValue(fieldName, value) {
        if ("creditPoolType" === fieldName) {
            this.setState({creditPoolType: value});
        }
    }

	onChangeCreditPoolType = (creditPoolType) => {
		this.setState({creditPoolType: creditPoolType});
	}

	render() {
		const fields = [
			{
				label: "Havuz Numarası",
				accessor: "creditPoolId",
				type: "text",
				operator: "="
			},
			{
				label: "Müşteri Adı",
				accessor: "customerName",
				type: "text",
				operator: "="
			},
			{
				label: "Unvan",
				accessor: "formattedName",
				type: "text",
				operator: "="
			},
			{
				label: "VKN/TCKN",
				accessor: "vknTckn",
				type: "numericText",
				operator: "="
			}
		];

		if (EntegratorIdentifiers.DEVATEK === EntegratorConf.identifier) {
			fields.push({
				label: "Havuz Türü",
				accessor: "creditPoolType",
				type: "select",
				operator: "=",
				selectData: enumToSelectData(CreditPoolType, false),
				initialValue: CreditPoolType.DOCUMENT_COUNT.value
			});
		}

		const columns = [
			{
				Header: "#",
				accessor: "index",
				sortable: false,
				Cell: row => <div>{row.index + 1}</div>
			},
			{
				Header: "Kredi Havuzu Numarası",
				accessor: "creditPoolId",
				sortable: true,
				Cell: row => <div>{row.creditPoolId}</div>
			},
			{
				Header: "VKN / TCKN",
				accessor: "customerVknTckn",
				sortable: true,
				Cell: row => <div>{row.customerVknTckn}</div>
			},
			{
				Header: "Unvan",
				accessor: "formattedName",
				sortable: true,
				Cell: row => <div>{row.formattedName}</div>
			},
			{
				Header: "Müşteri Adı",
				accessor: "customerName",
				sortable: true,
				Cell: row => (
					<div>
						<TextOverFlowTooltip text={row.customer ? row.customer.customerName : ""} maxLength={23} />
					</div>
				)
			},
			{
				Header: "İşlemler",
				accessor: "actions",
				sortable: false,
				Cell: row => (
					<button className="MenuBtn2 listt btn btn-default"
							onClick={() => this.openAddPoolModalAsEdit(row.creditPoolId)}>
						<span>Düzenle</span>
					</button>
				)
			}
		];

		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
					<StickButton className='stickButton plus-circle' position="leftSide"
								 onClick={() => this.setState({ addPoolModal: true })} label="Yeni Oluştur"
								 title="Yeni Oluştur"/>
				</NavBarKS>

				<div className="col-md-12 satirBasi">
					<div className="card-header ">
						<h4 className="card-title">Kredi Havuzu Listesi</h4>
					</div>

					<div className="card-body">
						<DetailedSearch fields={fields}
										loading={this.state.searching}
										onSearch={this.handleSearch}
										from={"creditPoolList"}
										onFieldValueChange={this.onChangeSearchFieldsValue}/>
					</div>
				</div>

				<div className="card-body row">
					<table >
						<thead>
						{(!this.state.noResult && false) &&
							<td colSpan={columns.length}>
								<div className="col-sm-12 row" style={{justifyContent: "center"}}>
									<div style={{marginTop:'20px'}}>
										<Pagination
											selectComponentClass={Select}
											showSizeChanger
											showQuickJumper={false}
											showPrevNextJumpers={true}
											showTotal={(total) => `Kayıt Sayısı : ${total}`}
											defaultPageSize={this.state.size}
											hideOnSinglePage={false}
											pageSizeOptions={["5", "10", "20", "50", "100"]}
											pageSize={this.state.size}
											onShowSizeChange={this.onShowSizeChange}
											onChange={this.onChange}
											total={this.state.total}
											className='pagi'
											locale={locale}
											current={this.state.page + 1}
											showLessItems
										/>
									</div>
								</div>
							</td>
						}
						<tr>
							{columns.map((col, index) => (
								<th key={index}>{col.Header}</th>
							))}
						</tr>
						</thead>
						<tbody>
						{!this.state.noResult && this.state.data ?
							this.state.data.map((content, index) =>
								<tr key={index}>
									{columns.map((col, colIndex) => (
										<td key={colIndex}>
											{col.accessor === "index" ? index + 1 :
												col.accessor === "actions" ? col.Cell(content) :
													content[col.accessor] || "-"}
										</td>
									))}
								</tr>
							)
							:
							<tr>
								<td colSpan={columns.length} style={{fontSize: '13px', fontWeight: 'bold'}}>
									Kayıt bulunamadı.
								</td>
							</tr>
						}
						</tbody>
						{!this.state.noResult &&
							<Footer total={this.state.total}
									length={columns.length}
									pageSize={this.pageSize}
									options={["5", "10", "20", "50", "100"]}
									page={this.state.page}
									size={this.state.size}
									hide={true}
							/>
						}
					</table>
				</div>

				<Modal isOpen={this.state.addPoolModal} size="lg">
					<ModalHeader toggle={this.closeAddPoolModal}>
						{this.state.mode === 'create' ? 'Yeni Havuz Oluştur' : 'Kredi Havuzunu Düzenle'}
					</ModalHeader>
					<ModalBody>
						<CreateCreditPool
							mode={this.state.mode}
							selectedRow={this.state.selectedRow}
							closeAddPoolModal={this.closeAddPoolModal}
							creditPoolType={this.state.creditPoolType}
							onChangeCreditPoolType={this.onChangeCreditPoolType}/>
					</ModalBody>
				</Modal>

				<Modal isOpen={this.state.observeModal} size="md">
					<ModalHeader toggle={() => this.setState({ observeModal: false })}>Havuzdaki Müşteriler</ModalHeader>
					<ModalBody>
						{this.state.poolCustomers.map(c =>
							<div key={c.recordId}>
								{c.vknTckn} - {c.formattedName}
								<br/>
								<hr/>
							</div>
						)}
					</ModalBody>
				</Modal>
			</div>
		);
	}

}

export default CreditPoolList;